import { z } from 'zod';

export const EmailBaseSchema = z.object({
  template: z.string().min(1),
  // If the CS team was notified in slack
  notifiedFailure: z.boolean().optional(),
});
